import Header from "./shared/header";
import TextContainer from "./shared/textContainer";
import Strategy from "./shared/strategy";
import Product from "./shared/product";
import Deployement from "./shared/deployement";
import WhitePaper from "./shared/whitepaper";
import Contact from "./shared/contact";
import Footer from "./shared/footer";

import HeroBackground from "./shared/hero_background";
import DesktopLayout from "./shared/desktop_layout";
import MobileLayout from "./shared/mobile_layout";
import { useState, useEffect } from "react";
import MobileHero from "./shared/mobile_hero";
import DesktopHero from "./shared/desktop_hero";

function AnalyticsAndML() {
  const strategyDataMobile = [
    {
      img: "images/analytics-and-ml/platform.webp",
      title: "Hundred Foot Overview",
      description:
        "Help define an analytics & machine learning strategy, identify key use-cases and initiatives that are relevant to their businesses, and establish ML processes, governance and ethics.",
    },
    {
      img: "images/analytics-and-ml/bird.webp",
      title: "Fine Tuned to Requirements",
      description:
        "Develop diagnostic, predictive and prescriptive models for a variety of purposes including: anomaly detection, forecasting, recommendations, root cause analysis and hundreds of other specific requirements.",
    },
    {
      img: "images/analytics-and-ml/insights.webp",
      title: "Deployment and Beyond",
      description:
        "Deploy MLOps tools and processes for model training and re-training, labeling, experimentation, monitoring, deployment, versioning, maintenance, testing and governance.",
    },
  ];

  const strategyDataWeb = [
    {
      img: "images/analytics-and-ml/strategy/img1.png",
      title: "Strategy",
      description:
        "Help define an analytics & machine learning strategy, identify key use-cases and initiatives that are relevant to their businesses, and establish ML processes, governance and ethics.",
    },
    {
      img: "images/analytics-and-ml/strategy/img2.png",
      title: "Model Development",
      description:
        "Develop diagnostic, predictive and prescriptive models for a variety of purposes including:anomaly detection, next best action, forecasting, recommendations, root cause analysis, churn prediction, customer segmentation, etc.",
    },

    {
      img: "images/analytics-and-ml/strategy/img3.png",
      title: "Deployment and Beyond",
      description:
        "Deploy MLOps tools and processes for model training and re-training, labeling, experimentation, monitoring, deployment, versioning, maintenance, testing and governance.",
    },
  ];

  const productList = [
    {
      title: "Marketing Optimization",
      description:
        "Use ML to analyze customer behavior and preferences, enabling targeted marketing strategies.",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.80563 4.13861C6.85411 4.04165 6.9532 3.98041 7.0616 3.98041L15.2219 3.98044V8.81943H4.46522L6.80563 4.13861ZM16.7829 8.81943V3.98044L24.9431 3.98047C25.0515 3.98047 25.1506 4.04171 25.1991 4.13866L27.5395 8.81943H16.7829ZM16.0024 10.3804H28.0219V27.7332C28.0219 27.8913 27.8937 28.0194 27.7357 28.0194H4.26903C4.11098 28.0194 3.98285 27.8913 3.98285 27.7332V10.3804H16.0024ZM7.0616 2.41943C6.36195 2.41943 5.72235 2.81473 5.40945 3.44052L2.50427 9.25087C2.45009 9.35925 2.42188 9.47875 2.42188 9.59992V27.7332C2.42188 28.7534 3.24888 29.5804 4.26903 29.5804H27.7357C28.7558 29.5804 29.5828 28.7534 29.5828 27.7332V9.59992C29.5828 9.47875 29.5546 9.35925 29.5004 9.25087L26.5953 3.44057C26.2824 2.81479 25.6428 2.4195 24.9431 2.41949L16.0024 2.41946L7.0616 2.41943ZM11.7357 15.2194C11.3046 15.2194 10.9552 15.5689 10.9552 15.9999C10.9552 16.431 11.3046 16.7804 11.7357 16.7804H20.269C20.7001 16.7804 21.0495 16.431 21.0495 15.9999C21.0495 15.5689 20.7001 15.2194 20.269 15.2194H11.7357Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
    {
      title: "Churn Prediction",
      description:
        "Predict customer churn and proactively take retention measures using advanced analytics.",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.40473 8.53361C4.40473 6.25383 6.25285 4.4057 8.53264 4.4057C10.8124 4.4057 12.6605 6.25383 12.6605 8.53361C12.6605 10.8134 10.8124 12.6615 8.53264 12.6615C6.25285 12.6615 4.40473 10.8134 4.40473 8.53361ZM8.53264 2.84473C5.39075 2.84473 2.84375 5.39173 2.84375 8.53361C2.84375 11.6755 5.39075 14.2225 8.53264 14.2225C11.6745 14.2225 14.2215 11.6755 14.2215 8.53361C14.2215 5.39173 11.6745 2.84473 8.53264 2.84473ZM12.7885 23.4667L5.15473 27.6896V19.2437L12.7885 23.4667ZM5.54354 17.6749C4.66788 17.1905 3.59375 17.8238 3.59375 18.8245V28.1088C3.59375 29.1095 4.66789 29.7428 5.54354 29.2584L13.9351 24.6163C14.8389 24.1163 14.8389 22.817 13.9351 22.317L5.54354 17.6749ZM17.8854 19.2002C17.8854 18.4746 18.4736 17.8864 19.1992 17.8864H27.7326C28.4582 17.8864 29.0464 18.4746 29.0464 19.2002V27.7335C29.0464 28.4591 28.4582 29.0474 27.7326 29.0474H19.1992C18.4736 29.0474 17.8854 28.4591 17.8854 27.7335V19.2002ZM19.4464 19.4474V27.4864H27.4854V19.4474H19.4464ZM28.5511 4.5521C28.8559 4.2473 28.8559 3.75313 28.5511 3.44833C28.2463 3.14353 27.7521 3.14353 27.4473 3.44833L23.4659 7.4298L19.4845 3.44838C19.1797 3.14358 18.6855 3.14358 18.3807 3.44838C18.0759 3.75318 18.0759 4.24736 18.3807 4.55216L22.3621 8.53358L18.3807 12.515C18.0759 12.8198 18.0759 13.314 18.3807 13.6188C18.6855 13.9236 19.1797 13.9236 19.4845 13.6188L23.4659 9.63735L27.4473 13.6188C27.7521 13.9236 28.2463 13.9236 28.5511 13.6188C28.8559 13.314 28.8559 12.8198 28.5511 12.515L24.5697 8.53358L28.5511 4.5521Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
    {
      title: "predictive maintenance",
      description:
        "Apply ML to forecast equipment maintenance needs, minimizing downtime and costs.",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.60134 2.41943C10.0324 2.41943 10.3818 2.76887 10.3818 3.19992V4.83895H21.6209V3.19992C21.6209 2.76887 21.9703 2.41943 22.4013 2.41943C22.8324 2.41943 23.1818 2.76887 23.1818 3.19992V4.83895H26.668C28.1192 4.83895 29.2956 6.01538 29.2956 7.46659V26.6666C29.2956 28.1178 28.1192 29.2942 26.668 29.2942H5.33467C3.88346 29.2942 2.70703 28.1178 2.70703 26.6666V7.46659C2.70703 6.01539 3.88346 4.83895 5.33467 4.83895H8.82085V3.19992C8.82085 2.76887 9.17029 2.41943 9.60134 2.41943ZM21.6209 6.39992V7.46659C21.6209 7.89764 21.9703 8.24708 22.4013 8.24708C22.8324 8.24708 23.1818 7.89764 23.1818 7.46659V6.39992H26.668C27.2571 6.39992 27.7347 6.87748 27.7347 7.46659V11.2389H4.26801V7.46659C4.26801 6.87749 4.74557 6.39992 5.33467 6.39992H8.82085V7.46659C8.82085 7.89764 9.17029 8.24708 9.60134 8.24708C10.0324 8.24708 10.3818 7.89764 10.3818 7.46659V6.39992H21.6209ZM4.26801 12.7999V26.6666C4.26801 27.2557 4.74557 27.7333 5.33467 27.7333H26.668C27.2571 27.7333 27.7347 27.2557 27.7347 26.6666V12.7999H4.26801ZM14.9347 15.9999C14.9347 15.4108 15.4122 14.9333 16.0013 14.9333C16.5904 14.9333 17.068 15.4108 17.068 15.9999C17.068 16.589 16.5904 17.0666 16.0013 17.0666C15.4122 17.0666 14.9347 16.589 14.9347 15.9999ZM20.268 14.9333C19.6789 14.9333 19.2013 15.4108 19.2013 15.9999C19.2013 16.589 19.6789 17.0666 20.268 17.0666C20.8571 17.0666 21.3347 16.589 21.3347 15.9999C21.3347 15.4108 20.8571 14.9333 20.268 14.9333ZM23.468 15.9999C23.468 15.4108 23.9456 14.9333 24.5347 14.9333C25.1238 14.9333 25.6013 15.4108 25.6013 15.9999C25.6013 16.589 25.1238 17.0666 24.5347 17.0666C23.9456 17.0666 23.468 16.589 23.468 15.9999ZM24.5347 19.1999C23.9456 19.1999 23.468 19.6775 23.468 20.2666C23.468 20.8557 23.9456 21.3333 24.5347 21.3333C25.1238 21.3333 25.6013 20.8557 25.6013 20.2666C25.6013 19.6775 25.1238 19.1999 24.5347 19.1999ZM19.2013 20.2666C19.2013 19.6775 19.6789 19.1999 20.268 19.1999C20.8571 19.1999 21.3347 19.6775 21.3347 20.2666C21.3347 20.8557 20.8571 21.3333 20.268 21.3333C19.6789 21.3333 19.2013 20.8557 19.2013 20.2666ZM16.0013 19.1999C15.4122 19.1999 14.9347 19.6775 14.9347 20.2666C14.9347 20.8557 15.4122 21.3333 16.0013 21.3333C16.5904 21.3333 17.068 20.8557 17.068 20.2666C17.068 19.6775 16.5904 19.1999 16.0013 19.1999ZM10.668 20.2666C10.668 19.6775 11.1456 19.1999 11.7347 19.1999C12.3238 19.1999 12.8013 19.6775 12.8013 20.2666C12.8013 20.8557 12.3238 21.3333 11.7347 21.3333C11.1456 21.3333 10.668 20.8557 10.668 20.2666ZM7.46801 19.1999C6.8789 19.1999 6.40134 19.6775 6.40134 20.2666C6.40134 20.8557 6.8789 21.3333 7.46801 21.3333C8.05711 21.3333 8.53467 20.8557 8.53467 20.2666C8.53467 19.6775 8.05711 19.1999 7.46801 19.1999ZM6.40134 24.5333C6.40134 23.9442 6.8789 23.4666 7.46801 23.4666C8.05711 23.4666 8.53467 23.9442 8.53467 24.5333C8.53467 25.1224 8.05711 25.5999 7.46801 25.5999C6.8789 25.5999 6.40134 25.1224 6.40134 24.5333ZM11.7347 23.4666C11.1456 23.4666 10.668 23.9442 10.668 24.5333C10.668 25.1224 11.1456 25.5999 11.7347 25.5999C12.3238 25.5999 12.8013 25.1224 12.8013 24.5333C12.8013 23.9442 12.3238 23.4666 11.7347 23.4666ZM14.9347 24.5333C14.9347 23.9442 15.4122 23.4666 16.0013 23.4666C16.5904 23.4666 17.068 23.9442 17.068 24.5333C17.068 25.1224 16.5904 25.5999 16.0013 25.5999C15.4122 25.5999 14.9347 25.1224 14.9347 24.5333ZM20.268 23.4666C19.6789 23.4666 19.2013 23.9442 19.2013 24.5333C19.2013 25.1224 19.6789 25.5999 20.268 25.5999C20.8571 25.5999 21.3347 25.1224 21.3347 24.5333C21.3347 23.9442 20.8571 23.4666 20.268 23.4666Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
    {
      title: "demand forecasting",
      description:
        "Utilize analytics to predict demand patterns, ensuring optimal inventory levels.",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.5357 2.41943C24.9667 2.41943 25.3162 2.76887 25.3162 3.19992V28.7999C25.3162 29.231 24.9667 29.5804 24.5357 29.5804C24.1046 29.5804 23.7552 29.231 23.7552 28.7999V3.19992C23.7552 2.76887 24.1046 2.41943 24.5357 2.41943ZM20.269 6.6861C20.7001 6.6861 21.0495 7.03554 21.0495 7.46659V28.7999C21.0495 29.231 20.7001 29.5804 20.269 29.5804C19.838 29.5804 19.4885 29.231 19.4885 28.7999V7.46659C19.4885 7.03554 19.838 6.6861 20.269 6.6861ZM28.8024 6.6861C29.2334 6.6861 29.5828 7.03554 29.5828 7.46659V28.7999C29.5828 29.231 29.2334 29.5804 28.8024 29.5804C28.3713 29.5804 28.0219 29.231 28.0219 28.7999V7.46659C28.0219 7.03554 28.3713 6.6861 28.8024 6.6861ZM11.7357 8.81943C12.1667 8.81943 12.5162 9.16887 12.5162 9.59992V28.7999C12.5162 29.231 12.1667 29.5804 11.7357 29.5804C11.3046 29.5804 10.9552 29.231 10.9552 28.7999V9.59992C10.9552 9.16887 11.3046 8.81943 11.7357 8.81943ZM3.20236 10.9528C3.63341 10.9528 3.98285 11.3022 3.98285 11.7333V28.7999C3.98285 29.231 3.63341 29.5804 3.20236 29.5804C2.77131 29.5804 2.42188 29.231 2.42188 28.7999V11.7333C2.42188 11.3022 2.77131 10.9528 3.20236 10.9528ZM16.0024 10.9528C16.4334 10.9528 16.7829 11.3022 16.7829 11.7333V28.7999C16.7829 29.231 16.4334 29.5804 16.0024 29.5804C15.5713 29.5804 15.2219 29.231 15.2219 28.7999V11.7333C15.2219 11.3022 15.5713 10.9528 16.0024 10.9528ZM7.46903 15.2194C7.90008 15.2194 8.24952 15.5689 8.24952 15.9999V28.7999C8.24952 29.231 7.90008 29.5804 7.46903 29.5804C7.03798 29.5804 6.68854 29.231 6.68854 28.7999V15.9999C6.68854 15.5689 7.03798 15.2194 7.46903 15.2194Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
    {
      title: "Fraud prediction",
      description:
        "Implement ML algorithms to identify and prevent fraudulent activities in real-time.",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.9968 2.09961C11.8544 2.09961 8.49635 5.45769 8.49635 9.6001C8.49635 13.7425 11.8544 17.1006 15.9968 17.1006C20.1392 17.1006 23.4973 13.7425 23.4973 9.6001C23.4973 5.45769 20.1392 2.09961 15.9968 2.09961ZM10.0573 9.6001C10.0573 6.31979 12.7165 3.66058 15.9968 3.66058C19.2771 3.66058 21.9364 6.31979 21.9364 9.6001C21.9364 12.8804 19.2771 15.5396 15.9968 15.5396C12.7165 15.5396 10.0573 12.8804 10.0573 9.6001ZM6.11566 29.0129C6.11566 25.3044 7.09256 22.7622 8.73628 21.1422C10.3823 19.52 12.8212 18.7002 16.0017 18.7002C19.1822 18.7002 21.6212 19.5201 23.2672 21.1422C24.911 22.7622 25.888 25.3044 25.8879 29.0129C25.8879 29.444 26.2373 29.7934 26.6684 29.7934C27.0994 29.7934 27.4489 29.444 27.4489 29.0129C27.4489 25.0416 26.3992 22.0372 24.3629 20.0304C22.329 18.026 19.4345 17.1392 16.0017 17.1392C12.5689 17.1392 9.67449 18.026 7.64058 20.0304C5.60438 22.0372 4.55469 25.0416 4.55469 29.0129C4.55469 29.444 4.90412 29.7934 5.33518 29.7934C5.76623 29.7934 6.11566 29.444 6.11566 29.0129Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
    {
      title: "price optimization",
      description:
        "Develop models to optimize pricing strategies based on market trends and competition.",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.4422 0.349125C18.773 0.490681 18.9642 0.840058 18.905 1.19499L16.9232 13.0862H26.6685C26.9641 13.0862 27.2344 13.2532 27.3666 13.5176C27.4988 13.7821 27.4703 14.0985 27.2929 14.335L14.4929 31.4016C14.277 31.6895 13.8923 31.7925 13.5615 31.6509C13.2307 31.5093 13.0395 31.16 13.0986 30.805L15.0805 18.9138H5.33518C5.03955 18.9138 4.7693 18.7468 4.63709 18.4824C4.50488 18.218 4.53341 17.9016 4.71079 17.6651L17.5108 0.598388C17.7267 0.310524 18.1114 0.207568 18.4422 0.349125ZM6.89615 17.3529H16.0018C16.2313 17.3529 16.4491 17.4538 16.5974 17.6289C16.7457 17.8039 16.8094 18.0354 16.7717 18.2617L15.1646 27.9044L25.1075 14.6472H16.0018C15.7724 14.6472 15.5546 14.5462 15.4063 14.3712C15.258 14.1961 15.1943 13.9647 15.232 13.7384L16.8391 4.09559L6.89615 17.3529Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
  ];

  const WhitePapercardData = [
    {
      img: "images/analytics-and-ml/10x.webp",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.0076 1.87109C8.20455 1.87109 1.87891 8.19674 1.87891 15.9998C1.87891 23.8028 8.20455 30.1285 16.0076 30.1285C23.8106 30.1285 30.1363 23.8028 30.1363 15.9998C30.1363 8.19674 23.8106 1.87109 16.0076 1.87109ZM3.90557 15.9998C3.90557 9.31604 9.32385 3.89776 16.0076 3.89776C22.6913 3.89776 28.1097 9.31604 28.1097 15.9998C28.1097 22.6835 22.6913 28.1018 16.0076 28.1018C9.32385 28.1018 3.90557 22.6835 3.90557 15.9998ZM10.7504 19.6565C10.4134 19.1733 9.74851 19.0548 9.26534 19.3919C8.78216 19.7289 8.66368 20.3938 9.00071 20.877C10.5409 23.0851 13.1032 24.5334 16.0039 24.5334C18.9046 24.5334 21.4669 23.0851 23.0071 20.877C23.3441 20.3938 23.2256 19.7289 22.7425 19.3919C22.2593 19.0548 21.5944 19.1733 21.2574 19.6565C20.099 21.3171 18.1779 22.4001 16.0039 22.4001C13.83 22.4001 11.9088 21.3171 10.7504 19.6565ZM11.4672 14.6136C12.4982 14.6136 13.3339 13.7777 13.3339 12.7469C13.3339 11.7162 12.4982 10.8803 11.4672 10.8803C10.4363 10.8803 9.60057 11.7162 9.60057 12.7469C9.60057 13.7777 10.4363 14.6136 11.4672 14.6136ZM22.4006 12.7469C22.4006 13.7777 21.5648 14.6136 20.5339 14.6136C19.503 14.6136 18.6672 13.7777 18.6672 12.7469C18.6672 11.7162 19.503 10.8803 20.5339 10.8803C21.5648 10.8803 22.4006 11.7162 22.4006 12.7469Z"
              fill="black"
            />
          </g>
        </svg>
      ),
      title: "Improve Campaign Efficiency",
      description:
        "Achieved a 10x improvement in campaign efficiency over hard-coded offers for a telecommunications company using an NBO framework consisting of multiple propensity, persuadability and revenue optimization models.",
    },
    {
      img: "images/analytics-and-ml/400x.webp",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.78117 24.3922C7.36461 23.9757 7.36461 23.3003 7.78117 22.8837L21.9603 8.70462L12.8021 8.70462C12.213 8.70462 11.7354 8.22706 11.7354 7.63796C11.7354 7.04885 12.213 6.57129 12.8021 6.57129L24.5354 6.57129C24.8183 6.57129 25.0896 6.68367 25.2897 6.88371C25.4897 7.08375 25.6021 7.35506 25.6021 7.63796L25.6021 19.3713C25.6021 19.9604 25.1245 20.438 24.5354 20.438C23.9463 20.438 23.4688 19.9604 23.4688 19.3713L23.4688 10.2131L9.28966 24.3922C8.87311 24.8088 8.19773 24.8088 7.78117 24.3922Z"
              fill="black"
            />
          </g>
        </svg>
      ),
      title: "Increased Take Up Rates",
      description:
        "A 400% improvement in take-up rates was experienced, for customised offers using active learning, hierarchical clustering and multi-armed bandit optimization to come up with the right campaign strategy.",
    },
    {
      img: "images/analytics-and-ml/90x.webp",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16 0.388672C16.5891 0.388672 17.0667 0.866235 17.0667 1.45534V4.24332C22.8099 4.8548 27.3423 9.51959 27.7479 15.322H30.9333C31.5224 15.322 32 15.7996 32 16.3887C32 16.9778 31.5224 17.4553 30.9333 17.4553H27.7094C27.1133 23.0541 22.6654 27.502 17.0667 28.0981V31.322C17.0667 31.9111 16.5891 32.3887 16 32.3887C15.4109 32.3887 14.9333 31.9111 14.9333 31.322V28.1365C9.13092 27.7309 4.46613 23.1986 3.85465 17.4553H1.06667C0.477563 17.4553 0 16.9778 0 16.3887C0 15.7996 0.477563 15.322 1.06667 15.322H3.81623C4.23202 9.37355 8.98488 4.6207 14.9333 4.2049V1.45534C14.9333 0.866235 15.4109 0.388672 16 0.388672ZM17.0667 26.0574V20.6553C17.0667 20.0662 16.5891 19.5887 16 19.5887C15.4109 19.5887 14.9333 20.0662 14.9333 20.6553V26.1038C10.251 25.709 6.49006 22.0779 5.89534 17.4553H11.7333C12.3224 17.4553 12.8 16.9778 12.8 16.3887C12.8 15.7996 12.3224 15.322 11.7333 15.322H5.84895C6.25605 10.4935 10.1048 6.64472 14.9333 6.23763V12.122C14.9333 12.7111 15.4109 13.1887 16 13.1887C16.5891 13.1887 17.0667 12.7111 17.0667 12.122V6.28401C21.6892 6.87874 25.3204 10.6397 25.7151 15.322H20.2667C19.6776 15.322 19.2 15.7996 19.2 16.3887C19.2 16.9778 19.6776 17.4553 20.2667 17.4553H25.6687C25.0926 21.9335 21.5448 25.4813 17.0667 26.0574Z"
              fill="black"
            />
          </g>
        </svg>
      ),
      title: "Reduced Errors",
      description:
        "Estimated reduction of 90% in passenger misconnections in over 3 months using .a multi-objective optimization system in one of Asia’s busiest airports",
    },
  ];

  const deployementData = [
    {
      title: "NEXT BEST OFFER / Action",
      description:
        "Set of recommendation, propensity and persuadability models for deciding the next best offers/actions in a way that optimizes both take-up rate and net revenue impact",
      img: "images/analytics-and-ml/Deployement/deployement-1.webp",
      img_mob: "images/analytics-and-ml/Deployement/deployement-1_mob.webp",
    },
    {
      title: "AI-POWERED CAmpaIGN Automation",
      description:
        "Framework for automatically designing, deploying, measuring and periodically reconfiguring a large number of campaigns so as to optimize key metrics like take-up rate and revenue impact in an iterative manner",
      img: "images/analytics-and-ml/Deployement/deployement-2.webp",
      img_mob: "images/analytics-and-ml/Deployement/deployement-2_mob.webp",
    },
    {
      title: "EXPLAINABLE AI",
      description:
        "Framework for understanding top features of models, as well as explanations for predictions for a given point.",
      img: "images/analytics-and-ml/Deployement/deployement-3.webp",
      img_mob: "images/analytics-and-ml/Deployement/deployement-3_mob.webp",
    },
    {
      title: "MARKETING ML",
      description:
        "Framework for Market Mix Modeling, Multi-Channel Attribution and Full-Funnel measurement.",
      img: "images/analytics-and-ml/Deployement/deployement-4.webp",
      img_mob: "images/analytics-and-ml/Deployement/deployement-4_mob.webp",
    },
  ];

  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const Layout = ({ children, backgroundColor }) => {
    return screenSize <= 768 ? (
      <MobileLayout backgroundColor={backgroundColor}>{children}</MobileLayout>
    ) : (
      <DesktopLayout backgroundColor={backgroundColor}>
        {children}
      </DesktopLayout>
    );
  };

  return (
    <div>
      <DesktopHero
        heroImage={"images/analytics-and-ml/hero.webp"}
        heading="Define and Operationalize Machine Learning-driven use-cases"
        title={"MACHINE LEARNING"}
        backgroundColor="green"
        name="analytics-and-ml"
      />

      <MobileHero
        heading={" Define your organisation’s machine learning strategy."}
        title="MACHINE LEARNING"
        backgroundColor="green"
      />

      <Layout>
        <div className=" sm:hidden w-[88%] mx-auto">
          <div>&nbsp;</div>
          <img
            src="/images/analytics-and-ml/machine_learning_hero_mob.webp"
            alt="frame1"
            className=" mt-[40px]"
          />
        </div>
      </Layout>

      <Layout>
        <TextContainer
          text1="OnebyZero has a team of skilled ML architects,  data scientists and machine learning engineers that can formulate the right ML problem definitions, define the right metrics and loss functions, extract, clean and validate data, build models, deploy them, and continuously improve the models to achieve desired metrics."
          text2="We have experience in variety of classical and deep ML models for use-cases around  marketing, next-best offers, churn prediction, campaign optimization, predictive maintenance, revenue forecasting, demand forecasting, inventory optimization, logistics, planning and scheduling, credit scoring, price & demand sensitivity models, fraud detection, etc."
        />
      </Layout>
      <Layout backgroundColor="black">
        <Strategy
          title={"Why work with OneByZero on Machine Learning?"}
          description={`OneByZero has deep experience in the end-to-end machine learning lifecycle, from defining the problem statement, building models and deploying them in production.`}
          img="images/analytics-and-ml/strategy.webp"
          dataMobile={strategyDataMobile}
          dataWeb={strategyDataWeb}
        />
      </Layout>
      <Layout>
        <Product
          title={"Improve metrics for various use-cases"}
          description={`OnebyZero takes a metrics-driven approach in all Machine Learning projects. We steadily aim to improve different kinds of technical metrics (precision, recall, accuracy, MAE, MAPE, NDGC, etc) as well business metrics (number of users, sessions, revenue, etc). in an iterative manner using a combination of experimentation and exploitation of learnings.`}
          list={productList}
        />
      </Layout>
      <Layout backgroundColor="black">
        <Deployement
          title={"Accelerated Deployment"}
          description={
            "OnebyZero’ uses several accelerators in the space of Machine Learning to speed up the deployment of use-cases."
          }
          data={deployementData}
        />
      </Layout>
      <Layout>
        <WhitePaper
          heading={"Meet your business goals with Analytics"}
          subHeading={"Welcome to the future of business."}
          title={"Go Deeper with Analytics and ML"}
          description={
            "Discover how you can improve customer satisfaction rates and lower churn by increasing the number of channels you interact with customers"
          }
          cardData={WhitePapercardData}
        />
      </Layout>
      <Layout backgroundColor="black">
        <Contact
          title={
            "See how Machine Learning can revolutionize your business - from marketing to operations to revenue"
          }
          type="service"
        />
        <Footer />
      </Layout>
    </div>
  );
}

export default AnalyticsAndML;
